<template>
  <v-container fluid>
    <portal to="app-header">
      {{ $t('bottleneckMachineDashboard') }}
    </portal>
    <component :is="component" />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ProductionSupervisorDashboard from '../components/ProductionSupervisorDashboard.vue';

export default {
  name: 'bottleneckMachineDashboard',
  components: {
    ProductionSupervisorDashboard,
  },
  computed: {
    ...mapGetters('user', ['roleName']),
    ...mapState('user', ['licenses']),
    // isCnc() {
    //   return this.licenses.length === 1 && this.licenses[0].assetId === 9;
    // },
    component() {
      return 'production-supervisor-dashboard';
    },
  },
};
</script>
